import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { TextArea } from "@ui/components/Inputs";
import { useTranslations } from "@ui/providers/useTranslations";

import type { ContestEntry } from "@jti/rest-api";

import styles from "./LoyaltyContactFormTextArea.module.scss";

export type LoyaltyContactFormTextAreaProps = {
  id: string;
  label: string;
  required?: boolean;
  validationErrorMessage?: string;
  placeholder?: string;
};

export const LoyaltyContactFormTextArea: FC<LoyaltyContactFormTextAreaProps> = ({
  id,
  label,
  required,
  validationErrorMessage,
  placeholder = "",
}) => {
  const { control } = useFormContext();
  const { __ } = useTranslations();

  const handleChangeValue = (e: React.ChangeEvent<HTMLTextAreaElement>, onChange: (value: ContestEntry) => void) => {
    const inputValue = e.target.value;
    onChange({
      question: label,
      answers: [inputValue],
    });
  };

  const validateQuestionField = (value: ContestEntry) => {
    const answer = value?.answers?.[0]?.trim();
    if (!answer && required) {
      return validationErrorMessage ?? __("contact.form.requiredmessage");
    }
    return true;
  };

  return (
    <div className={styles.textareaWrapper}>
      <Controller
        name={id}
        control={control}
        defaultValue={{ question: label, answers: [""] }}
        rules={{
          validate: validateQuestionField,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextArea
            {...field}
            id={id}
            label={label}
            isError={!!error}
            errorText={error?.message}
            required={required}
            isOptionalLabelVisible={!required}
            value={field.value?.answers?.[0] || ""}
            placeholder={placeholder}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeValue(e, field.onChange)}
          />
        )}
      />
    </div>
  );
};
